let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fbz3S")).then(() => parcelRequire('bp2ak'));